import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1987c6ac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "view-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "heading-title" }, "Enrollments", -1))
const _hoisted_3 = {
  key: 0,
  class: "heading-subtitle"
}
const _hoisted_4 = {
  key: 1,
  class: "heading-subtitle"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://padmin.com/contact/",
  target: "_blank"
}, "Contact Us", -1))
const _hoisted_6 = {
  key: 2,
  class: "mb-4 container"
}
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "enrollment-card container pt-2 px-0" }
const _hoisted_10 = { class: "enrollment-header d-flex justify-content-between align-items-center" }
const _hoisted_11 = { class: "enrollment-img" }
const _hoisted_12 = { class: "enrollment-name" }
const _hoisted_13 = {
  key: 0,
  class: "days-remaining"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_15 = { key: 0 }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = {
  key: 1,
  class: "cobra-election-submitted"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_19 = ["onClick"]
const _hoisted_20 = {
  key: 0,
  class: "my-table-row"
}
const _hoisted_21 = { class: "the-col" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "the-label" }, "Qualifying Event Date", -1))
const _hoisted_23 = { class: "the-value the-number" }
const _hoisted_24 = {
  key: 1,
  class: "my-table-row"
}
const _hoisted_25 = { class: "the-col" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "the-label" }, "Coverage Start Date", -1))
const _hoisted_27 = { class: "the-value the-number" }
const _hoisted_28 = {
  key: 2,
  class: "my-table-row"
}
const _hoisted_29 = { class: "the-col" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "the-label" }, "Enrollment Period", -1))
const _hoisted_31 = { class: "the-value the-number sm" }
const _hoisted_32 = {
  key: 3,
  class: "my-table-row"
}
const _hoisted_33 = { class: "the-col" }
const _hoisted_34 = { class: "the-label" }
const _hoisted_35 = { class: "the-value the-number" }
const _hoisted_36 = { class: "buttons" }
const _hoisted_37 = ["onClick"]
const _hoisted_38 = {
  key: 2,
  class: "enroll-complete-label",
  style: {"color":"#888","font-weight":"bold"}
}
const _hoisted_39 = ["onClick"]
const _hoisted_40 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_ctx.enrollments.length > 0)
      ? (_openBlock(), _createElementBlock("p", _hoisted_3, " Below are the enrollments available to you. To start the enrollment process, select an option below to continue. "))
      : _createCommentVNode("", true),
    (_ctx.enrollments.length == 0)
      ? (_openBlock(), _createElementBlock("p", _hoisted_4, [
          _createTextVNode(" Our system indicates that you do not have any benefits to enroll in. If you believe this is incorrect, please click "),
          _hoisted_5,
          _createTextVNode(" to connect with P&A Group's Participant Support Center. ")
        ]))
      : _createCommentVNode("", true),
    (_ctx.enrollments.length > 0)
      ? (_openBlock(), _createElementBlock("form", _hoisted_6, [
          (_ctx.validationMsg)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "alert alert-danger",
                innerHTML: _ctx.validationMsg
              }, null, 8, _hoisted_7))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.enrollments, (enrollment) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "enrollment-layout grid-col-12 grid-md-4 col-sm-6 mb-4",
                key: enrollment.customerParticipantId
              }, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, _toDisplayString(enrollment.customerName) + " - " + _toDisplayString(_ctx.getServiceTypeLabel(enrollment.serviceType)) + " " + _toDisplayString(enrollment.serviceType == 0 ? "Election" : "Enrollment"), 1),
                      (
                    enrollment.serviceType == 1 ||
                    enrollment.cobra.status !== 10
                  )
                        ? (_openBlock(), _createElementBlock("p", _hoisted_13, [
                            _createTextVNode(_toDisplayString(_ctx.getDaysRemainingMessage(enrollment)) + " ", 1),
                            _hoisted_14,
                            (
                      enrollment.serviceType == 1 &&
                      enrollment.openEnrollment.status == 10
                    )
                              ? (_openBlock(), _createElementBlock("span", _hoisted_15, [
                                  _createTextVNode(" You have submitted this enrollment. Your confirmation is " + _toDisplayString(enrollment.openEnrollment.electionID) + ". Click ", 1),
                                  _createElementVNode("a", {
                                    class: "confirmation-download-btn",
                                    onClick: ($event: any) => (
                        _ctx.downloadConfirmationAsPdf(
                          enrollment.customerParticipantId
                        )
                      )
                                  }, "here", 8, _hoisted_16),
                                  _createTextVNode(" to download the confirmation. ")
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        : (_openBlock(), _createElementBlock("p", _hoisted_17, [
                            _createTextVNode(" Election Submitted. Your confirmation is " + _toDisplayString(enrollment.cobra?.electionID) + ". ", 1),
                            _hoisted_18,
                            _createTextVNode(" Click "),
                            _createElementVNode("a", {
                              onClick: ($event: any) => (_ctx.startEnrollment(enrollment)),
                              class: "finished-cobra-button"
                            }, "here", 8, _hoisted_19),
                            _createTextVNode(" for more info. ")
                          ]))
                    ])
                  ]),
                  (enrollment.serviceType == 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                        _createElementVNode("div", _hoisted_21, [
                          _hoisted_22,
                          _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.formatDate(enrollment.cobra.qualifyingEventDate)), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (enrollment.serviceType == 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                        _createElementVNode("div", _hoisted_25, [
                          _hoisted_26,
                          _createElementVNode("div", _hoisted_27, _toDisplayString(enrollment.cobra.coverageEndDate
                      ? _ctx.addDayAndFormat(enrollment.cobra.coverageEndDate)
                      : "Not available"), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (enrollment.serviceType == 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                        _createElementVNode("div", _hoisted_29, [
                          _hoisted_30,
                          _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.formatDate(enrollment.openEnrollment.enrollmentStartDate) +
                    " to " +
                    _ctx.formatDate(enrollment.openEnrollment.enrollmentEndDate)), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (enrollment.serviceType == 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                        _createElementVNode("div", _hoisted_33, [
                          _createElementVNode("div", _hoisted_34, _toDisplayString(enrollment.openEnrollment.benefitEndDate
                      ? "Coverage Period"
                      : "Coverage Start Date"), 1),
                          _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.formatDate(enrollment.openEnrollment.benefitEffectiveDate) +
                    (enrollment.openEnrollment.benefitEndDate
                      ? " to " +
                        _ctx.formatDate(enrollment.openEnrollment.benefitEndDate!)
                      : "")), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_36, [
                    (
                  enrollment.serviceType == 0 &&
                  enrollment.cobra &&
                  enrollment.cobra.status === 10
                )
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          type: "button",
                          class: "enroll-button",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => {
                  _ctx.helper.setPageStep(_ctx.common.pageStep.confirmation);
                  _ctx.$router.push({ name: _ctx.routesPath.applicationSuccessful });
                }),
                          style: {"background-color":"#aaa","cursor":"pointer"}
                        }, " Election Submitted "))
                      : (
                  enrollment.serviceType == 0 &&
                  enrollment.cobra &&
                  enrollment.cobra.status !== 10 &&
                  !_ctx.isEnrollmentEnded(enrollment)
                )
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            type: "button",
                            class: "enroll-button",
                            onClick: ($event: any) => (_ctx.startEnrollment(enrollment))
                          }, _toDisplayString(enrollment.cobra.started
                    ? "Continue Enrollment"
                    : "Start Enrollment"), 9, _hoisted_37))
                        : (
                  enrollment.serviceType == 1 &&
                  enrollment.openEnrollment &&
                  enrollment.openEnrollment.status === 10 &&
                  _ctx.isEnrollmentEnded(enrollment)
                )
                          ? (_openBlock(), _createElementBlock("span", _hoisted_38, " Enrollment Complete "))
                          : (
                  enrollment.serviceType == 1 &&
                  enrollment.openEnrollment &&
                  enrollment.openEnrollment.status === 10 &&
                  !_ctx.isEnrollmentEnded(enrollment)
                )
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 3,
                                type: "button",
                                class: "enroll-button",
                                onClick: ($event: any) => (_ctx.startEnrollment(enrollment))
                              }, " Change Enrollment ", 8, _hoisted_39))
                            : (
                  enrollment.serviceType == 1 &&
                  enrollment.openEnrollment &&
                  enrollment.openEnrollment.status !== 10 &&
                  !_ctx.isEnrollmentEnded(enrollment)
                )
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 4,
                                  type: "button",
                                  class: "enroll-button",
                                  onClick: ($event: any) => (_ctx.startEnrollment(enrollment))
                                }, _toDisplayString(enrollment.openEnrollment.started
                    ? "Continue Enrollment"
                    : "Start Enrollment"), 9, _hoisted_40))
                              : _createCommentVNode("", true)
                  ])
                ])
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}